// extracted by mini-css-extract-plugin
export default {"link":"link__5b1a1ed4"};